module.exports = __webpack_public_path__ + "static/media/trial1-after-10-sek-if-correct.3eb7126b.mp3";